import { ImageUrl } from "src/redux/apiTypes";

export const getCategoriesIcon = (imageUrl: ImageUrl): string | null => {
  const previewImage = imageUrl?.svg || imageUrl?.png;

  return previewImage || null;
};
